 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		5: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"default~article-article-module~author-author-module~category-category-module~custom-page-custom-page~7d4e3baa","1":"default~article-article-module~author-author-module~category-category-module~custom-page-custom-page~363eb0b9","2":"common","3":"default~content-articles-articles-module~content-custom-pages-custom-pages-module~content-newsletter~efe4ceb7","4":"default~content-ads-ads-module~content-article-article-module~content-custom-page-custom-page-module~a14ae9cf","6":"default~content-article-article-module~content-custom-page-custom-page-module~content-featured-artic~0af68393","7":"default~content-article-article-module~content-custom-page-custom-page-module~quill","8":"default~author-author-module~tag-tag-module","9":"default~content-article-article-module~content-custom-page-custom-page-module","10":"default~content-footer-footer-module~content-sidebar-sidebar-module","11":"article-article-module","12":"author-author-module","13":"author-profile-author-profile-module","14":"category-category-module","15":"content-ads-ads-module","16":"content-article-article-module","17":"content-articles-articles-module","18":"content-articles-day-editor-articles-day-editor-module","19":"content-button-links-button-links-module","20":"content-categories-categories-module","21":"content-custom-page-custom-page-module","22":"content-custom-pages-custom-pages-module","23":"content-featured-articles-featured-articles-module","24":"content-footer-footer-module","25":"content-header-buttons-header-buttons-module","26":"content-images-images-module","27":"content-newsletter-newsletter-module","28":"content-sidebar-sidebar-module","29":"content-tags-tags-module","30":"content-users-users-module","31":"custom-page-custom-page-module","32":"dashboard-dashboard-module","33":"home-home-module","34":"login-login-module","36":"page-not-found-page-not-found-module","37":"pages-admin-container-container-module","38":"pages-public-public-routing-public-routing-module","41":"search-search-module","43":"tag-tag-module","44":"temporary-page-hledame-temporary-page-hledame-module","45":"temporary-page-newsletter-temporary-page-newsletter-module","46":"temporary-page-o-nas-temporary-page-o-nas-module","47":"temporary-page-prispejte-temporary-page-prispejte-module","48":"temporary-page-rss-temporary-page-rss-module"}[chunkId]||chunkId) + "-es2015." + {"0":"8cd71f13bec111e94ed4","1":"b5cdf337d7022f5e540f","2":"a1c40a4f9b9252035d3b","3":"c60f8f05b11c73f25fdb","4":"bd6bcf54bff475fae4a2","6":"40b6ce4586d4cae952d1","7":"8dfa18ded12c3f024b3a","8":"f48f5c24a1a2c66b3f74","9":"dabe13bf3716e47f6d57","10":"3556a23b71185eccd952","11":"5ef72b32288d222ae55f","12":"5956b90d016540f4630f","13":"663cbb6b72d2201ad112","14":"56f3b55c11d893ed7a78","15":"2aa06b276cd63889bf1a","16":"b26588e58a07cad2c7f1","17":"b3178b3f1660d400b380","18":"c266e1d8b4fb7a95eacf","19":"60d18579614494e901c0","20":"ef15d1b9eaf3d061d1ed","21":"5c16d3325b3e4bb1c9c8","22":"1ee2a2ac0853b7507a07","23":"9e76319af0fe471bcecc","24":"26fc16d7052dda19f38c","25":"1e3ccc5a4ba3627a34d2","26":"6181a2ab99e040a4e588","27":"ee3277cd09f98a9b71ab","28":"95ec12016a09f4e00bd1","29":"3383b90238c6b0a46863","30":"f1b854e395249715480d","31":"6639f50a9477e5044801","32":"6413aa4fc9014139a7b2","33":"db73ddd2d9c08b7c79ec","34":"d465766c0101f5727522","36":"aaf686f5334f293af7b0","37":"371bce648f2d94fc8b35","38":"8cb7e68ed8a1a871b8ca","41":"a68f6022fecb7c7e0922","43":"85e9d31ed4438e545540","44":"bb96fb2fe2cdd77f7839","45":"54249d485bd35dda7632","46":"613b06c4ce78f3a404f1","47":"a83ddef4769784a3a8ba","48":"acc2afb07cb0fa964dca"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
